import * as type from './types'


export function createVtParamMap(vtParamMap) {
    return {
        type : type.CREATE_VTPARAMMAP,
        payload : vtParamMap,
        txn : 'initiated',
    };
}


export function savedVtParamMap(vtParamMap, status = 'success', msg = 'Saved successfully.') {
    return {
        type : type.SAVED_VTPARAMMAP,
        payload : vtParamMap,
        txn : status,
        msg,
        diff : true
    };
}


export function editVtParamMap(vtParamMap) {
    return {
        type : type.EDIT_VTPARAMMAP,
        payload : vtParamMap,
        txn : 'initiated',
    };
}


export function fetchVtParamMap() {
    return {
        type : type.FETCH_VTPARAMMAP,
    };
}


export function fetchedVtParamMap(vtParamMap) {
    return {
        type : type.FETCHED_VTPARAMMAP,
        payload : vtParamMap
    };
}


export function searchVtParamMap(vtParamMap) {
    return {
        type : type.SEARCH_VTPARAMMAP,
        payload : vtParamMap
    };
}


export function storeSearchVtParamMapResult(vtParamMap) {
    return {
        type : type.STORE_SEARCH_VTPARAMMAP_RESULT,
        payload : vtParamMap
    };
}


export function deleteVtParamMap(vtParamMap) {
    return {
        type : type.DELETE_VTPARAMMAP,
        payload: vtParamMap
    };
}


export function deletedVtParamMap(msg) {
    return {
        type : type.DELETED_VTPARAMMAP,
        payload : msg
    };
}


export function setNotifyDone(props) {
    return {
        type : type.NOTIFICATION_DONE_VTPARAMMAP,
        payload: props
    };
}


export function filterItems(options) {
    return {
        type : type.FILTER_ITEMS,
        payload: options
    };
}


export function setRowIndex(options) {
    return {
        type : type.SET_ROW_INDEX_VTPARAMMAP,
        payload: options
    };
}